function normalizeGameRecord(game, fallbackId = "") {
  if (typeof game === "string" || typeof game === "number") {
    if (fallbackId !== "") {
      return {
        gameId: String(fallbackId).trim(),
        gameName: String(game).trim() || String(fallbackId).trim(),
      };
    }
    return { gameId: String(game).trim(), gameName: String(game).trim() };
  }

  const gameId = String(
    fallbackId !== ""
      ? fallbackId
      : game?.gameId ?? game?.gameID ?? game?.gameid ?? game?.id ?? game?.value ?? "",
  ).trim();
  if (!gameId) return null;

  return {
    ...(game && typeof game === "object" ? game : {}),
    gameId,
    gameName:
      String(game?.gameName ?? game?.name ?? game?.description ?? fallbackId ?? gameId).trim() ||
      gameId,
  };
}

export function normalizeAnakatechGames(response) {
  const payload = response?.data ?? response ?? {};
  const source =
    payload.gameIdsToGamesData ??
    payload.gameIds ??
    payload.games ??
    payload.result ??
    payload;
  let normalizedGames = [];

  if (Array.isArray(source)) {
    normalizedGames = source
      .map((game) => normalizeGameRecord(game))
      .filter(Boolean);
  } else if (source && typeof source === "object") {
    normalizedGames = Object.entries(source)
      .map(([gameId, game]) => normalizeGameRecord(game, gameId))
      .filter(Boolean);
  }

  const gamesById = new Map();
  const repeatedIds = new Set();
  for (const game of normalizedGames) {
    if (gamesById.has(game.gameId)) {
      repeatedIds.add(game.gameId);
      continue;
    }
    gamesById.set(game.gameId, game);
  }

  const uniqueGames = [...gamesById.values()];
  const nameOccurrences = new Map();
  for (const game of uniqueGames) {
    const normalizedName = game.gameName.toLocaleLowerCase("es");
    nameOccurrences.set(normalizedName, (nameOccurrences.get(normalizedName) || 0) + 1);
  }

  return uniqueGames.map((game) => {
    const hasRepeatedName =
      nameOccurrences.get(game.gameName.toLocaleLowerCase("es")) > 1;
    if (!repeatedIds.has(game.gameId) && !hasRepeatedName) return game;
    return { ...game, gameName: `${game.gameId} - ${game.gameName}` };
  });
}

export function buildAnakatechGameNameIndex(response) {
  return new Map(
    normalizeAnakatechGames(response).map((game) => [game.gameId, game.gameName]),
  );
}

export function getAnakatechGameId(game) {
  if (typeof game === "string" || typeof game === "number") {
    return String(game).trim();
  }
  const id = game?.gameId ?? game?.gameID ?? game?.gameid ?? game?.id ?? game?.value;
  return id === null || id === undefined ? "" : String(id).trim();
}
